import { render, staticRenderFns } from "./tbr-edm-list.vue?vue&type=template&id=304a4ef2&scoped=true&"
import script from "./tbr-edm-list.vue?vue&type=script&lang=js&"
export * from "./tbr-edm-list.vue?vue&type=script&lang=js&"
import style0 from "./tbr-edm-list.vue?vue&type=style&index=0&id=304a4ef2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304a4ef2",
  null
  
)

export default component.exports